import { Switch } from "@/components/ui";
import { routes } from "@/routes/utils";
import moment from "moment";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetSchoolsQuery } from "@/services";
import { useAppDispatch } from "@/redux/hooks";
import { useQueryClient } from "@tanstack/react-query";
import { openSnackbarAction } from "@/redux/slices";
import useToogleSchoolMutation from "@/services/school/useToogleSchoolMutation";

const useSchool = () => {
  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  // Define Table Columns
  const columns = [
    {
      accessorKey: "schoolName",
      header: <div>School Name</div>,
      cell: (row: any) => (
        <span
          className="text-primary font-normal cursor-pointer"
          onClick={()=>onRowClick(row.row.original)}
        >
          {String(row?.row?.original?.schoolName || "A")}
        </span>
      ),
      size: 80,
    },
    {
      accessorKey: "contactNo",
      header: <div>Contact No.</div>,
      accessorFn: (row: any) => String(row?.phoneNumber || ""),
    },
    {
      accessorKey: "state",
      header: <div>State</div>,
      accessorFn: (row: any) => String(row?.state || ""),
    },
    {
      accessorKey: "city",
      header: <div>City</div>,
      accessorFn: (row: any) => String(row?.city || ""),
    },
    {
      accessorKey: "createdAt",
      header: <div>Onboarding Date</div>,
      accessorFn: (row: any) =>
        row?.createdAt
          ? moment(row?.createdAt).format("DD-MM-YYYY")
          : "",
    },
    // {
    //   accessorKey: "action",
    //   header: <div>Action</div>,
    //    cell: (row: any) => (<Switch checked={row.row.original.status} className="cursor-pointer"
    //       onCheckedChange={() => toggleSchool({ id: row.row.original.schoolId })}/>)
    // },
  ];

  const onAdd = () => {
    navigate(`${routes.add}`);
  };

  const onRowClick = (row: any) => {
    navigate(`${row.schoolId}/${routes.edit}`);
  };

  const onCancelFilter = () => {
    setOpenFilter(false);
  };

  const onFilterBtnClick = () => {
    setOpenFilter(true);
  };

  const params = useMemo(() => {
  const baseParams: any = {
    page: pageNumber + 1,
    limit: pageSize,
    orderBy: "createdAt",
    orderDirection: "DESC",
    status: "ACTIVE",
  };

  return {
    ...baseParams,
    ...filterData, // include filter fields
  };
}, [pageNumber, pageSize, filterData]);


  const { mutate: toggleSchool } = useToogleSchoolMutation({
    onSuccess: () => {
      dispatch(
        openSnackbarAction({
          message: "School Status Updated Successfully",
          severity: "success",
        })
      );
        queryClient.invalidateQueries({ queryKey: ["school"] });
    },
    onError: () => {
      dispatch(
        openSnackbarAction({
          message: "Failed to update status",
          severity: "error",
        })
      );
    },
  });
  const { data, isPending, isError } = useGetSchoolsQuery(params);

  const tableData = data?.data?.[0]?.records || [];
 const totalRecords = data?.data?.[0]?.pagination?.[0]?.totalRecords || 0;
 const totalPages = Math.ceil(totalRecords / pageSize);

  return {
    columns,
    onAdd,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    isPending,
    isError,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
  };
};

export default useSchool;
